module.exports = __webpack_public_path__ + "static/media/delivery.ab2e648c.svg";